"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ButtonIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@chakra-ui/react");
var verdigris_1 = require("@codametrix/verdigris");
var classnames_1 = __importDefault(require("classnames"));
var DEFAULT_BUTTON_ACTION_STATE = {
    visible: true,
    enabled: true
};
var ButtonIcon = function (props) {
    var isAttached = props.isAttached, label = props.label, iconName = props.iconName, className = props.className, _a = props.actionsState, actionsState = _a === void 0 ? DEFAULT_BUTTON_ACTION_STATE : _a, spreadable = __rest(props, ["isAttached", "label", "iconName", "className", "actionsState"]);
    if (!actionsState.visible) {
        // return an empty span - easier for ts to handle than
        // a false atm.
        return (0, jsx_runtime_1.jsx)("span", {}, label);
    }
    var classes = (0, classnames_1["default"])(className, 'icon-button', {
        'icon-disabled': !actionsState.enabled,
        'icon-enabled': actionsState.enabled,
        'icon-visible': actionsState.visible
    });
    var title = actionsState.enabled
        ? "".concat(props.label)
        : "Unable to ".concat(props.label);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(react_1.Button, __assign({}, spreadable, { 
            //as="a"
            mr: isAttached ? '-px' : undefined, isDisabled: !actionsState.enabled, className: classes, "aria-label": title, title: title }, { children: (0, jsx_runtime_1.jsx)(verdigris_1.BiomeIcon, { iconName: iconName }) })) }));
};
exports.ButtonIcon = ButtonIcon;
ButtonIcon.displayName = 'ButtonIcon';
//# sourceMappingURL=button-icon.js.map